import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47d7825d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "monitoring-tickets-table__block"
}
const _hoisted_2 = { class: "monitoring-tickets-table__main" }
const _hoisted_3 = { class: "monitoring-tickets-table__list" }
const _hoisted_4 = {
  key: 1,
  class: "monitoring-tickets-table__no-find-tasks"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "monitoring-tickets-table__no-find-tasks-title" }, "Данные не найдены", -1))
const _hoisted_6 = { key: 1 }

import { PaginationRequestModel, PaginationResponseModel } from '@/models';
import {
  TirPmIconView,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmPagination,
  TirPmScrollbar,
} from 'tir-components';
import { computed, onMounted, PropType, ref, watch } from 'vue';
import { MonitoringsAdapterService } from '../../adapter-service';
import {
  GetProjectTasksRequestModel,
  TaskColumnModel,
  TaskFilterModel,
  TaskModel,
} from '../../models';
import { useRouter } from 'vue-router';
import { TaskViewElementEnum } from '../../enums';
import { debounce } from 'tir-pm-debounce';
import { TaskDrawer, TaskDrawerSettingsModel } from '@/components';
import GetEmployeesWithAccessToProjectItemModel from '../../models/GetEmployeesWithAccessToProjectItemModel';
import { MagnifyingGlassIcon } from 'tir-style-system/icons/outline';
import { MonitoringsSkeleton } from '../../monitorings-skeleton';
import { TaskCardMonitoring } from '../../components/task-card-monitoring';
import { TaskCardMonitoringHeader } from '../../components/task-card-monitoring-header';

/**адаптер */
const DEFAULT_PAGE_STEP = 10;

/**Колонки */

export default /*#__PURE__*/_defineComponent({
  __name: 'monitoring-tickets-table',
  props: {
  /**Поиск */
  search: { type: String, required: true },
  /**Выбранный исполнитель */
  selectPerformer: { type: Object as PropType<GetEmployeesWithAccessToProjectItemModel> },
  /**Поиск исполнителей */
  searchPerformers: { type: String },
  /**Начальная дата */
  selectDateStart: { type: Date },
  /**Конечная дата */
  selectDateEnd: { type: Date },
},
  emits: ["openTaskDrawer", "getTotalWorkTime"],
  setup(__props, { emit }) {

const props = __props;

const adapter = new MonitoringsAdapterService();

/**Роутер */
const router = useRouter();





/**id проекта */
const projectId = router.currentRoute.value.params.projectId;
/**Загрузка */
const loading = ref(false);

/**Дефолтное кол-во элементов на странице */
const columns: TaskColumnModel[] = [
  new TaskColumnModel({
    Type: TaskViewElementEnum.Performers,
    Name: 'Исполнители',
    Width: '4.125rem',
    MinWidth: '4.1875rem',
    Align: 'left',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Namespace,
    Name: '',
    Width: '1.5rem',
    MinWidth: '1.5rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Queue,
    Name: 'Очередь',
    Width: '9.375rem',
    MinWidth: '9.375rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Number,
    Name: '№',
    Width: '5rem',
    MinWidth: '5rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Name,
    Name: 'Название',
    Width: '50vw',
    MinWidth: '20rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Status,
    Name: 'Статус',
    Width: '7.688rem',
    MinWidth: '7.688rem',
    Align: 'right',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Priority,
    Name: 'Приоритет',
    Width: '4rem',
    MinWidth: '4rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Difficulty,
    Name: 'Сложность',
    Width: '2rem',
    MinWidth: '2rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.EstimateTime,
    Name: 't (оценка)',
    Width: '5rem',
    MinWidth: '5rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.WorkTime,
    Name: 't (затрачено)',
    Width: '5rem',
    MinWidth: '5rem',
    Align: 'center',
  }),
];

/**Кол-во элементов на странице */
const pageStep = ref(DEFAULT_PAGE_STEP);

/**Ссылка на шторку задачи */
const $taskDrawer = ref<InstanceType<typeof TaskDrawer>>();

/**Список задач */
const tasks = ref([]);

/**Общее затраченное время */
const totalWorkTime = ref<number>(0);

/**Страница */
const pageResponse = ref<PaginationResponseModel<Array<TaskModel>>>();

/**Настройки видимости */
const viewSettings = ref([
  TaskViewElementEnum.Performers,
  TaskViewElementEnum.Namespace,
  TaskViewElementEnum.Queue,
  TaskViewElementEnum.Name,
  TaskViewElementEnum.Number,
  TaskViewElementEnum.Status,
  TaskViewElementEnum.Priority,
  TaskViewElementEnum.EstimateTime,
  TaskViewElementEnum.WorkTime,
]);

/**Текущая страница */
const currentPageRequest = computed(() => {
  if (pageResponse.value)
    return new PaginationRequestModel({
      Skip: pageResponse.value.Size * (pageResponse.value.Current - 1),
      Take: pageStep.value,
    });
});

/**Кол-во страниц */
const pagesCount = computed(
  () => pageResponse.value && Math.ceil(pageResponse.value.Count / pageResponse.value.Size),
);

/** Id выбранного исполнителя */
const selectedPerformerId = computed(() => {
  return props.selectPerformer && props.selectPerformer.UserId
    ? [props.selectPerformer.UserId]
    : [];
});

/** Получить список задач */
const getTasks = async (page: PaginationRequestModel, clear?: Boolean) => {
  loading.value = true;
  if (clear) {
    tasks.value = [];
  }
  const response = await adapter.getTasksByProjectId(
    new GetProjectTasksRequestModel({
      ProjectId: +projectId,
      Filter: new TaskFilterModel({
        Search: props.search || '',
        Performers: selectedPerformerId.value,
      }),
      DateStart: props.selectDateStart,
      DateEnd: props.selectDateEnd,
      Page: page,
    }),
  );

  if (response.IsSuccess) {
    pageResponse.value = response;
    totalWorkTime.value = response.TotalWorkTime;
    tasks.value = response?.Items.sort((a, b) => b.Id - a.Id) || [];
  } else {
    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: response.ErrorMessage ?? 'Ошибка получения списка задач',
        type: 'error',
        group: 'general',
        life: 5000,
        closable: true,
      }),
    );
  }

  loading.value = false;
  return response.IsSuccess;
};

/**Открыть шторку с задачей */
const openTaskDrawer = (taskId: number) => {
  $taskDrawer.value?.open(
    new TaskDrawerSettingsModel({
      Mode: 'edit',
      TaskId: taskId,
    }),
  );
};

/**Обновить список */
const updateList = async () => {
  await getTasks(
    new PaginationRequestModel({
      Skip: 0,
      Take: pageStep.value,
    }),
  );
};

/**Изменить кол-во элементов на странице */
const changePageStep = async (value: number) => {
  pageStep.value = value;
  await getTasks(
    new PaginationRequestModel({
      Skip: 0,
      Take: pageStep.value,
    }),
  );
};

/**Обновить текущую страницу */
const changeCurrentPage = async (value: number) => {
  if (!pageResponse.value) return;

  await getTasks(
    new PaginationRequestModel({
      Skip: pageResponse.value.Size * (value - 1),
      Take: pageStep.value,
    }),
  );
};

/**При поиске через debounce */
const debounceOnSearch = debounce(async () => {
  await getTasks(currentPageRequest.value, true);
  emit('getTotalWorkTime', totalWorkTime.value);
}, 300);

watch(
  () => props.search,
  () => {
    debounceOnSearch();
  },
);
watch(
  () => props.selectPerformer,
  async () => {
    await updateList();
    emit('getTotalWorkTime', totalWorkTime.value);
  },
);

watch(
  () => [props.selectDateStart, props.selectDateEnd],
  async () => {
    await updateList();
    emit('getTotalWorkTime', pageResponse.value.TotalWorkTime);
  },
  { immediate: true },
);

onMounted(async () => {
  await getTasks(
    new PaginationRequestModel({
      Skip: 0,
      Take: pageStep.value,
    }),
  );
});

return (_ctx: any,_cache: any) => {
  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (tasks.value.length)
          ? (_openBlock(), _createBlock(_unref(TirPmScrollbar), {
              key: 0,
              class: "monitoring-tickets-table__scrollbar",
              "show-on-hover": true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(TaskCardMonitoringHeader), {
                      class: "monitoring-tickets-table__columns-header",
                      columns: columns,
                      viewSettings: viewSettings.value
                    }, null, 8, ["viewSettings"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasks.value, (task) => {
                      return (_openBlock(), _createBlock(_unref(TaskCardMonitoring), {
                        monitoringTicketPage: "",
                        isPerformersLeftBlock: "",
                        key: task.Id,
                        task: task,
                        columns: columns,
                        viewSettings: viewSettings.value,
                        selectPerformer: __props.selectPerformer,
                        onOpenTaskDrawer: openTaskDrawer,
                        onRemoveTask: updateList
                      }, null, 8, ["task", "viewSettings", "selectPerformer"]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!tasks.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(TirPmIconView), {
                size: 80,
                isBordered: false
              }, {
                mainSlot: _withCtx(() => [
                  _createVNode(_unref(MagnifyingGlassIcon))
                ]),
                _: 1
              }),
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        (pageResponse.value?.Current && pagesCount.value)
          ? (_openBlock(), _createBlock(_unref(TirPmPagination), {
              key: 2,
              class: "monitoring-tickets-table__paginator",
              showMoreElements: "",
              "model-value": pageResponse.value.Current,
              "range-size": 3,
              pages: pagesCount.value,
              options: [10, 20, 30, 40, 50, 100],
              "count-elements": pageStep.value,
              "onUpdate:countElements": changePageStep,
              "onUpdate:modelValue": changeCurrentPage
            }, null, 8, ["model-value", "pages", "count-elements"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(TaskDrawer), {
          ref_key: "$taskDrawer",
          ref: $taskDrawer,
          "disable-events": ""
        }, null, 512)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createVNode(_unref(MonitoringsSkeleton))
      ]))
}
}

})